let initialState = {
    THEME: null,
    SYSTEM: {
        COMMUNICATION: {
            METHOD: "POLLING",
            POLLING: {
                INTERVAL: 1000,
            },
            SSE: {
                DOMAIN: ""
            }
        },
        DATE_FORMAT: {
            BIRTH_DATE: "YYYY.MM.DD",
            CREATE_DATE: "YYYY-MM-DD HH:mm",
            UPDATE_DATE: "YYYY-MM-DD HH:mm",
            DEFAULT_DATE: "YYYY-MM-DD HH:mm",
        },
        INPUT_MAX_LENGTH: {
            TEXT: 255,
            PASSWORD: 255,
            DATE: 8,
            EMAIL: 255,
            PHONE: 11,
            COMMENT: 1024
        },
        FILE_ACCEPT: {
            XLSX: ["xlsx"],
            EVALUATION_DOCUMENT: ["pdf"],
            EVALUATION_ATTACHMENT_FILE: ["pdf"],
        },
        FILE_UPLOAD_SIZE: {
            XLSX: 100,
            EVALUATION_DOCUMENT: 100,
            EVALUATION_ATTACHMENT_FILE: 100,
        },

        USER_AUTH: {
            PASSWORD: {
                ENABLE: false,
                REGEX: null,
                IS_ALPHABET: false,                        // /[a-zA-Z]/.test(password)
                IS_NUMBER: false,                          // /\d/.test(password)
                IS_SPECIAL_CHARACTERS: false,               // /[$@!%*#?&]/.test(password)
                IS_NEED_LENGTH_8: false,                     // password.length >= 8
                IS_NEED_LENGTH_10: false                    // password.length >= 10
            }
        },
        EVALUATOR_AUTH: {
            TYPE: "EMAIL_PASSWORD",
            PASSWORD: {
                ENABLE: false,
                REGEX: null,
                IS_ALPHABET: true,                          // /[a-zA-Z]/.test(password)
                IS_NUMBER: true,                            // /\d/.test(password)
                IS_SPECIAL_CHARACTERS: true,                // /[$@!%*#?&]/.test(password)
                IS_NEED_LENGTH_8: true,                     // password.length >= 8
                IS_NEED_LENGTH_10: false                    // password.length >= 10
            }
        },

        FUNC_EXTRACT_DATA: false,
        FUNC_EXTRACT_DATA_FOR_EVALUATOR_LEADER: false,

        ENABLE_EVALUATION_CATEGORY: false,
        ENABLE_RENDER_EVALUATOR_PARTICIPANT_CHANNEL: false,

        FUNC_EVALUATOR_DATA_UPDATE: false,
        FUNC_EVALUATOR_DATA_OPEN_TYPE: "MODAL", // MODAL or WINDOW

        EVALUATION_OPEN_STEP: "READY",

        // delete
        ENABLE_EVALUATION_GATHERING_SHOWN: false,
    },
    MAIN_MENU: {
        // 공통 메뉴
        BASE: true,
        BASE_MENUS: ["MEMBER"],

        // 관라지 메뉴
        // "DASHBOARD", "ORGANIZATION", "EVALUATOR", "EVALUATEE", "TEMPLATE"
        ADMIN: true,
        ADMIN_MENUS: ["DASHBOARD", "ORGANIZATION", "EVALUATOR", "TEMPLATE"],

        // 사용자 메뉴

        // 공통 메뉴
        // "EVALUATION", "EVALUATION_OPEN", "EVALUATION_CLOSE"
        EVALUATION: true,
        EVALUATION_MENUS: ["EVALUATION", "EVALUATION_OPEN", "EVALUATION_CLOSE"],
    },

    APP_MEMBER: {
        ENABLE: {
            ROLE: false,
            PHONE: true,
        },
        UNIQUE: {
            PHONE: true
        }
    },
    APP_ORGANIZATION: {
        ITEMS: {
            "role": false,
            "name": true,
            "email": true,
            "phone": true,
            "state": true,
            "createdDate": true,
            "updatedDate": true,
        },
        UNIQUE: {
            "email": true,                  // 이메일
            "phone": true,                  // 휴대폰번호
        },
        XLSX: {
            COLUMNS: [                      // state 사용 안됨
                {key: "name", require: true},
                {key: "email", require: false},
                {key: "phone", require: false},
            ],
            PARSER: {}
        },
        TABLE: {
            SORT: null,
            SEARCH_KEYS: ["name", "email", "phone"],
            COLUMNS: [
                {type: "select", key: "checkbox", style: {width: 46, minWidth: 46}},
                {type: "sort", key: "name", style: {width: "auto"}},
                {type: "sort", key: "email", style: {width: "15%"}},
                {type: "sort", key: "phone", style: {width: "15%"}},
                {type: "text", key: "state", style: {width: "15%"}},
                {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                {type: "text", key: "action", style: {minWidth: 180, width: 180}},
            ]
        }
    },
    APP_EVALUATOR_POOL: {
        ITEMS: {
            "type": true,                   // 유형
            "domain": true,                 // 분야
            "name": true,                   // 이름(필수)
            "gender": true,                 // 성별
            "birthDate": true,              // 생년월일
            "email": true,                  // 이메일
            "phone": true,                  // 휴대폰번호
            "organization": true,           // 소속
            "position": true,               // 직위
            "responsibility": false,        // 직책
            "rank": true,                   // 직급
            "major": true,                  // 전공
            "occupation": true,             // 직종
            "certificate1": true,           // 자격증1
            "certificate2": true,           // 자격증2
            "certificate3": true,           // 자격증3
            "homeAddress": true,            // 자택주소
            "companyAddress": true,         // 직장주소
            "remarks": true,                // 비고
            "createdDate": true,            // 생성일
            "updatedDate": true,            // 수정일
        },
        UNIQUE: {
            "email": true,                  // 이메일
            "phone": true,                  // 휴대폰번호
        },
        XLSX: {
            COLUMNS: [
                {key: "type", require: true},
                {key: "name", require: true},
                {key: "domain", require: true},
                {key: "gender", require: false},
                {key: "birthDate", require: false},
                {key: "occupation", require: false},
                {key: "organization", require: false},
                {key: "rank", require: false},
                {key: "position", require: false},
                {key: "major", require: false},
                {key: "email", require: false},
                {key: "phone", require: false},
                {key: "certificate1", require: false},
                {key: "certificate2", require: false},
                {key: "certificate3", require: false},
                {key: "remarks", require: false},
                {key: "homeAddress", require: false},
                {key: "companyAddress", require: false},
            ],
            PARSER: {
                "type": ["NONE", "INTERNAL", "EXTERNAL", "외부", "내부"],
                "gender": ["MALE", "FEMALE", "남", "여", "남자", "여자"],
                "birthDate": ["YYYYMMDD", "YYYY.MM.DD", "YYYY-MM-DD"],
            }
        },
        TABLE: {
            SORT: "domain,ASC&sort=name,ASC",
            SEARCH_KEYS: ["name", "email", "phone", "domain", "organization"],
            COLUMNS: [
                {type: "select", key: "checkbox", style: {width: 46, minWidth: 46}},
                {type: "text", key: "type", style: {width: "10%"}},
                {type: "text", key: "domain", style: {width: "10%"}},
                {type: "text", key: "name", style: {width: "auto"}},
                {type: "text", key: "birthDate", style: {width: "10%"}},
                {type: "text", key: "organization", style: {width: "10%"}},
                {type: "text", key: "position", style: {width: "10%"}},
                {type: "text", key: "email", style: {width: "10%"}},
                {type: "text", key: "phone", style: {width: "10%"}},
                {type: "text", key: "action", style: {minWidth: 180, width: 180}},
            ]
        },
        INFO: {
            COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
            COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
        },
        CREATE: {
            COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
            COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
            REQUIRE: ["type", "name", "email", "phone", "organization", "position"]
        },
        UPDATE: {
            COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
            COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
            REQUIRE: ["type", "name", "email", "phone", "organization", "position"]
        }
    },
    APP_EVALUATION_TEMPLATE: {
        ITEMS: {
            "name": true,
            "description": true,
            "createdDate": true,
            "updatedDate": true,
        },
        TABLE: {
            SORT: null,
            SEARCH_KEYS: ["name"],
            COLUMNS: [
                {type: "sort", key: "name", style: {width: "20%"}},
                {type: "text", key: "description", style: {width: "auto"}},
                {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                {type: "text", key: "action", style: {minWidth: 180, width: 180}},
            ]
        }
    },
    APP_EVALUATION: {
        ITEMS: {
            "status": true,                 // 상태
            "name": true,                   // 이름
            "code": true,                   // 코드
            "createdDate": true,            // 생성일
            "updatedDate": true,            // 수정일
        },
        TABLE: {
            SORT: null,
            SEARCH_KEYS: ["name", "code"],
            COLUMNS: [
                {type: "text", key: "status", style: {width: "12%"}},
                {type: "text", key: "code", style: {width: "12%"}},
                {type: "text", key: "name", style: {width: "auto"}},
                {type: "text", key: "location", style: {width: "12%"}},
                {type: "text", key: "orderDepartmentName", style: {width: "12%"}},
                {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
            ]
        }
    },
    PAGE_EVALUATOR: {
        MENUS: {
            ITEM: {
                SIGNATURE: true,

                COMMON: true,

                SIGNATURE_BOOK: true,
                AGREEMENT: true,
                QUESTION: true,
                SURVEY: true,
                EVALUATION: true,
                EVALUATOR_LEADER: false,
                GATHERING: true,
            },

            LIST: [
                {type: "ITEM", item: "SIGNATURE"},
                {type: "ITEM", item: "COMMON"},
                {type: "ITEM", item: "AGREEMENT"},
                {type: "ITEM", item: "QUESTION"},
                {type: "ITEM", item: "EVALUATION"},
                {type: "ITEM", item: "GATHERING"},
                {type: "ITEM", item: "SURVEY"},
                {type: "ITEM", item: "SIGNATURE_BOOK"},

                /*{type: "ITEM", item: "SIGNATURE"},
                {
                    type: "GROUP",
                    item: "GROUP_EVALUATOR",
                    children: [
                        {type: "ITEM", item: "COMMON"},
                        {type: "ITEM", item: "SIGNATURE_BOOK"},
                        {type: "ITEM", item: "AGREEMENT"},
                        {type: "ITEM", item: "QUESTION"},
                        {type: "ITEM", item: "EVALUATION"},
                        {type: "ITEM", item: "EVALUATOR_LEADER"},
                    ]
                },
                {
                    type: "GROUP",
                    item: "GROUP_RESULT",
                    children: [
                        {type: "ITEM", item: "GATHERING"},
                    ]
                },
                {
                    type: "GROUP",
                    item: "GROUP_ETC",
                    children: [
                        {type: "ITEM", item: "SURVEY"},
                        {type: "ITEM", item: "SIGNATURE_BOOK"},
                    ]
                },*/
            ],
            ENABLE_AT_STEP_WAIT: ["SIGNATURE", "COMMON", "AGREEMENT"],     // eval - wait or open
            ENABLE_AT_STEP_OPEN: ["SIGNATURE", "COMMON", "AGREEMENT", "QUESTION", "EVALUATION"],  // eval -  open
            ENABLE_AT_STEP_GATHERING: ["SIGNATURE", "COMMON", "AGREEMENT", "QUESTION", "EVALUATION", "GATHERING", "SURVEY", "SIGNATURE_BOOK"],   // eval -  open - gathering
            ENABLE_AT_STEP_RESULT: ["SIGNATURE", "COMMON", "AGREEMENT", "QUESTION", "EVALUATION", "GATHERING", "SURVEY", "SIGNATURE_BOOK"],
            ENABLE_AT_EVALUATOR: ["SIGNATURE", "COMMON", "AGREEMENT", "QUESTION", "EVALUATION", "GATHERING", "SIGNATURE_BOOK", "SURVEY"],
            ENABLE_AT_EVALUATOR_LEADER: ["SIGNATURE", "COMMON", "AGREEMENT", "QUESTION", "EVALUATION", "GATHERING", "SIGNATURE_BOOK", "SURVEY", "EVALUATOR_LEADER"],
        }
    },

    EVALUATION: {
        PARTICIPANT_ROLE_LIST: ["EVALUATOR", "EVALUATOR_LEADER"],
        PARTICIPANT_REF_DATA_LIST: ["PARTICIPANT_ROLE", "PARTICIPANT_NAME", "PARTICIPANT_EMAIL", "PARTICIPANT_PHONE", "PARTICIPANT_BIRTH_DATE", "PARTICIPANT_ORGANIZATION", "PARTICIPANT_POSITION", "ORGANIZATION_POSITION", "PARTICIPANT_NAME_ORGANIZATION_POSITION"],
        PARTICIPANT_COLOR_LIST: ["#228be6", "#fab005", "#40c057", "#be4bdb", "#e64980", "#748ffc", "#ffa94d", "#a9e34b", "#3bc9db", "#ff8787", "#1864ab", "#e67700", "#2b8a3e", "#862e9c", "#a61e4d", "#364fc7", "#d9480f", "#5c940d", "#0b7285", "#c92a2a",]
    },
    EVALUATION_MENU: {
        // 평가 정보
        // "INFO", "INFO_CATEGORY"
        INFO: true,
        INFO_MENUS: ["INFO", "INFO_CATEGORY"],

        // 평가 데이터
        // "DOC_DATA", "DOC_PARTI"
        COMMON_DATA: true,
        COMMON_DATA_MENUS: ["DOC_DATA", "DOC_PARTI"],

        // 문서 서식 - 공통
        // "DOC_COMMON", "DOC_SIGNATURE_BOOK"
        DOC_COMMON: true,
        DOC_COMMON_MENUS: ["DOC_COMMON", "DOC_SIGNATURE_BOOK"],

        // 문서 서식 - 피평가자
        DOC_EVALUATEE: false,
        DOC_EVALUATEE_MENUS: [],

        // 문서 서식 - 평가자
        // "DOC_AGREEMENT", "DOC_QUESTION", "DOC_SURVEY", "DOC_EVALUATION", "DOC_EVALUATOR_LEADER"
        DOC_EVALUATOR: true,
        DOC_EVALUATOR_MENUS: ["DOC_AGREEMENT", "DOC_QUESTION", "DOC_EVALUATION", "DOC_SURVEY"],

        // 문서 서식 - 취합지
        // "DOC_GATHERING
        DOC_GATHERING: true,
        DOC_GATHERING_MENUS: ["DOC_GATHERING"],

        // 문서 서식 - 결과지(사용 안함)
        DOC_RESULT: false,
        DOC_RESULT_MENUS: [],

        // 참여자(평가위원)
        // "EVALUATOR"
        PARTICIPANT: true,
        PARTICIPANT_MENUS: ["EVALUATOR"],
    },
    EVALUATION_OPEN_MENU: {
        /* 기본 정보 */
        INFO: true,
        INFO_MENUS: ["INFO"],

        /* 평가 정보 */
        EVALUATION: false,
        EVALUATION_MENUS: ["QUESTION"],             // "QUESTION", "EVALUATION"

        /* 결과 정보 */
        OUTPUT: true,
        OUTPUT_MENUS: ["OUTPUT_FILE"],
    },
    EVALUATION_CLOSE_MENU: {
        /* 기본 정보 */
        INFO: true,
        INFO_MENUS: ["INFO"],

        /* 참여자 정보 */
        PARTICIPANT: true,
        PARTICIPANT_MENUS: ["EVALUATOR"]
    },

    PARTICIPANT_EVALUATION: {
        LIST_PAGE_DATA: {
            search: "",
            page: 0,
            size: 5,
            order: "desc",
            orderBy: "createdDate",
        }
    },
    PARTICIPANT_EVALUATOR: {
        MENUS: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "AGREEMENT",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_WAIT: [
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_OPEN: [],
        DISABLE_MENUS_STEP_GATHERING: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_RESULT: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],

        FUNC_EVALUATOR_DATA: false,
        FUNC_EVALUATION_COMPLETE: false,
        COMPLETED_EVALUATION_STEP: ""
    },
    PARTICIPANT_EVALUATOR_LEADER: {
        MENUS: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_WAIT: [
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_OPEN: [],
        DISABLE_MENUS_STEP_GATHERING: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_RESULT: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],

        FUNC_EVALUATOR_DATA: true,
        FUNC_EVALUATION_COMPLETE: true,
        COMPLETED_EVALUATION_STEP: ""
    },
    PARTICIPANT_EVALUATOR_AND_LEADER: {
        MENUS: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_WAIT: [
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_OPEN: [],
        DISABLE_MENUS_STEP_GATHERING: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],
        DISABLE_MENUS_STEP_RESULT: [
            "SIGNATURE",
            "COMMON",
            "SIGNATURE_BOOK",
            "EVALUATION",
        ],

        FUNC_EVALUATOR_DATA: true,
        FUNC_EVALUATION_COMPLETE: true,
        COMPLETED_EVALUATION_STEP: ""
    },
    CUSTOM_RESOURCE: {
        LOGO: "images/logo.png",
        LOGO_MOBILE: "images/logo_mobile.png",
        PARTICIPANT_EVALUATOR_PAGE_SIGN: {
            TITLE: "인투소프트",
            BG: {
                PATH: "images/customer/bg.jpg",
                STYLE: {
                    "height": "200px",
                    "backgroundRepeat": "no-repeat",
                    "backgroundSize": "cover",
                    "backgroundPosition": "center"
                }
            },
            HEADER: {
                STYLE: {
                    height: 200,
                    padding: 30,
                },
                TITLE_STYLE: {
                    marginTop: 30,
                    color: "#FFFFFF",
                },
                SUB_TITLE_STYLE: {
                    display: "none",
                    color: "#FFFFFF",
                },
                LOGO: {
                    PATH: "images/customer/logo_white.svg",
                    STYLE: {
                        width: "auto",
                        height: 26,
                    }
                },
            },
            BODY: {
                STYLE: {
                    paddingTop: 30,
                },
            },
            FOOTER: {
                STYLE: {
                    textAlign: "center"
                },
                LOGO: {
                    PATH: "images/customer/logo.png",
                    STYLE: {
                        width: "auto",
                        height: 40,
                    }
                },
            },
        },
        PARTICIPANT_EVALUATOR_PAGE_MAIN: {
            LOGO: {
                PATH: "images/customer/logo.png",
                STYLE: {
                    width: "auto",
                    height: 30,
                }
            },
        },
    },
};

if (window.INTO_SETTINGS) {
    const globalIntoSettings = window.INTO_SETTINGS;

    if (globalIntoSettings.MODE) {
        const customMode = globalIntoSettings.MODE;
        if (customMode === "lhri") {
            initialState = {
                THEME: null,
                SYSTEM: {
                    // use
                    COMMUNICATION: {
                        METHOD: "POLLING",
                        POLLING: {
                            INTERVAL: 1000,
                        },
                        SSE: {
                            DOMAIN: ""
                        }
                    },
                    DATE_FORMAT: {
                        BIRTH_DATE: "YYYY.MM.DD",
                        CREATE_DATE: "YYYY-MM-DD HH:mm",
                        UPDATE_DATE: "YYYY-MM-DD HH:mm",
                        DEFAULT_DATE: "YYYY-MM-DD HH:mm",
                    },
                    INPUT_MAX_LENGTH: {
                        TEXT: 255,
                        PASSWORD: 255,
                        DATE: 8,
                        EMAIL: 255,
                        PHONE: 11,
                        COMMENT: 1024
                    },
                    FILE_ACCEPT: {
                        XLSX: ["xlsx"],
                        EVALUATION_DOCUMENT: ["pdf"],
                        EVALUATION_ATTACHMENT_FILE: ["pdf"],
                    },
                    FILE_UPLOAD_SIZE: {
                        XLSX: 100,
                        EVALUATION_DOCUMENT: 100,
                        EVALUATION_ATTACHMENT_FILE: 100,
                    },

                    USER_AUTH: {
                        PASSWORD: {
                            ENABLE: false,
                            REGEX: null,
                            IS_ALPHABET: false,                        // /[a-zA-Z]/.test(password)
                            IS_NUMBER: false,                          // /\d/.test(password)
                            IS_SPECIAL_CHARACTERS: false,               // /[$@!%*#?&]/.test(password)
                            IS_NEED_LENGTH_8: false,                     // password.length >= 8
                            IS_NEED_LENGTH_10: false                    // password.length >= 10
                        }
                    },
                    EVALUATOR_AUTH: {
                        TYPE: "EMAIL_PASSWORD",
                        PASSWORD: {
                            ENABLE: true,
                            REGEX: null,
                            IS_ALPHABET: true,                          // /[a-zA-Z]/.test(password)
                            IS_NUMBER: true,                            // /\d/.test(password)
                            IS_SPECIAL_CHARACTERS: true,                // /[$@!%*#?&]/.test(password)
                            IS_NEED_LENGTH_8: true,                     // password.length >= 8
                            IS_NEED_LENGTH_10: false                    // password.length >= 10
                        }
                    },
                    ENABLE_EVALUATION_CATEGORY: false,
                    ENABLE_RENDER_EVALUATOR_PARTICIPANT_CHANNEL: true,

                    FUNC_EXTRACT_DATA: false,
                    FUNC_EXTRACT_DATA_FOR_QUESTION: false,
                    FUNC_EXTRACT_DATA_FOR_EVALUATOR_LEADER: true,

                    FUNC_EVALUATOR_DATA_UPDATE: true,
                    FUNC_EVALUATOR_DATA_OPEN_TYPE: "WINDOW", // MODAL or WINDOW
                },
                MAIN_MENU: {
                    // 공통 메뉴
                    BASE: true,
                    BASE_MENUS: ["MEMBER"],

                    // 관라지 메뉴
                    // "DASHBOARD", "ORGANIZATION", "EVALUATOR", "TEMPLATE"
                    ADMIN: true,
                    ADMIN_MENUS: ["DASHBOARD", "ORGANIZATION", "EVALUATOR", "TEMPLATE"],

                    // 사용자 메뉴
                    // 공통 메뉴
                    // "EVALUATION", "EVALUATION_OPEN", "EVALUATION_CLOSE"
                    EVALUATION: true,
                    EVALUATION_MENUS: ["EVALUATION", "EVALUATION_OPEN", "EVALUATION_CLOSE"],
                },

                APP_MEMBER: {
                    ENABLE: {
                        ROLE: false,
                        PHONE: true,
                    },
                    UNIQUE: {
                        PHONE: true
                    }
                },
                APP_ORGANIZATION: {
                    ITEMS: {
                        "role": false,
                        "name": true,
                        "email": true,
                        "phone": true,
                        "state": true,
                        "createdDate": true,
                        "updatedDate": true,
                    },
                    UNIQUE: {
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                    },
                    XLSX: {
                        COLUMNS: [                          // state 사용 안됨
                            {key: "name", require: true},
                            {key: "email", require: false},
                            {key: "phone", require: false},
                        ],
                        PARSER: {}
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name", "email", "phone"],
                        COLUMNS: [
                            {type: "select", key: "checkbox", style: {width: 46, minWidth: 46}},
                            {type: "sort", key: "name", style: {width: "auto"}},
                            {type: "sort", key: "email", style: {width: "15%"}},
                            {type: "sort", key: "phone", style: {width: "15%"}},
                            {type: "text", key: "state", style: {width: "15%"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    }
                },
                APP_EVALUATOR_POOL: {
                    ITEMS: {
                        "type": true,                   // 분야
                        "name": true,                   // 이름(필수)
                        "gender": true,                 // 성별
                        "birthDate": true,              // 생년월일
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                        "organization": true,           // 소속
                        "position": true,               // 직위
                        "responsibility": false,        // 직책
                        "rank": true,                   // 직급
                        "major": true,                  // 전공
                        "occupation": true,             // 직종
                        "certificate1": true,           // 자격증1
                        "certificate2": true,           // 자격증2
                        "homeAddress": true,            // 자택주소
                        "companyAddress": true,         // 직장주소
                        "remarks": true,                // 비고
                        "createdDate": true,            // 생성일
                        "updatedDate": true,            // 수정일

                        "domain": true,                 // 분야
                        "certificate3": true,          // 자격증3
                    },
                    UNIQUE: {
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                    },
                    XLSX: {
                        COLUMNS: [
                            {key: "type", require: true},
                            {key: "name", require: true},
                            {key: "organization", require: true},
                            {key: "position", require: true},
                            {key: "email", require: true},
                            {key: "phone", require: true},

                            {key: "gender", require: false},
                            {key: "birthDate", require: false},
                            {key: "homeAddress", require: false},
                            {key: "companyAddress", require: false},
                            {key: "major", require: false},
                            {key: "remarks", require: false},
                        ],
                        PARSER: {
                            "type": ["NONE", "INTERNAL", "EXTERNAL", "외부", "내부"],
                            "gender": ["MALE", "FEMALE", "남", "여", "남자", "여자"],
                            "birthDate": ["YYYYMMDD", "YYYY.MM.DD", "YYYY-MM-DD"],
                        }
                    },
                    TABLE: {
                        SORT: "domain,ASC&sort=name,ASC",
                        SEARCH_KEYS: ["name", "email", "phone", "domain", "organization"],
                        COLUMNS: [
                            {type: "select", key: "checkbox", style: {width: 46, minWidth: 46}},
                            {type: "text", key: "type", style: {width: "15%"}},
                            {type: "text", key: "name", style: {width: "15%"}},
                            {type: "text", key: "organization", style: {width: "15%"}},
                            {type: "text", key: "position", style: {width: "15%"}},
                            {type: "text", key: "email", style: {width: "15%"}},
                            {type: "text", key: "phone", style: {width: "15%"}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    },
                    INFO: {
                        COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
                    },
                    CREATE: {
                        COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
                        REQUIRE: ["type", "name", "email", "phone", "organization", "position"]
                    },
                    UPDATE: {
                        COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
                        REQUIRE: ["type", "name", "email", "phone", "organization", "position"]
                    }
                },
                APP_EVALUATION_TEMPLATE: {
                    ITEMS: {
                        "name": true,
                        "description": true,
                        "createdDate": true,
                        "updatedDate": true,
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name"],
                        COLUMNS: [
                            {type: "sort", key: "name", style: {width: "20%"}},
                            {type: "text", key: "description", style: {width: "auto"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    }
                },
                APP_EVALUATION: {
                    ITEMS: {
                        "status": true,                 // 상태
                        "name": true,                   // 이름
                        "code": true,                   // 코드
                        "createdDate": true,            // 생성일
                        "updatedDate": true,            // 수정일
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name", "code"],
                        COLUMNS: [
                            {type: "text", key: "status", style: {width: "12%"}},
                            {type: "text", key: "code", style: {width: "12%"}},
                            {type: "text", key: "name", style: {width: "auto"}},
                            {type: "text", key: "location", style: {width: "12%"}},
                            {type: "text", key: "evaluationDate", style: {width: "12%"}},
                            {type: "text", key: "orderDepartmentName", style: {width: "12%"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                        ]
                    }
                },
                PAGE_EVALUATOR: {
                    MENUS: {
                        ITEM: {
                            SIGNATURE: true,

                            COMMON: true,

                            SIGNATURE_BOOK: true,
                            AGREEMENT: true,
                            QUESTION: true,
                            SURVEY: true,
                            EVALUATION: true,
                            EVALUATOR_LEADER: true,

                            GATHERING: true,
                        },

                        LIST: [
                            {type: "ITEM", item: "SIGNATURE"},
                            {type: "ITEM", item: "COMMON"},
                            {type: "ITEM", item: "AGREEMENT"},
                            {type: "ITEM", item: "EVALUATION"},
                            {type: "ITEM", item: "SIGNATURE_BOOK"},
                            {type: "ITEM", item: "GATHERING"},
                            {type: "ITEM", item: "EVALUATOR_LEADER"},
                        ],
                        ENABLE_AT_STEP_WAIT: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION"],     // eval - wait or open
                        ENABLE_AT_STEP_OPEN: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK"],  // eval -  open
                        ENABLE_AT_STEP_GATHERING: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],   // eval -  open - gathering
                        ENABLE_AT_STEP_RESULT: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],

                        ENABLE_AT_EVALUATOR: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK"],
                        ENABLE_AT_EVALUATOR_LEADER: ["SIGNATURE", "COMMON", "AGREEMENT", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],
                    }
                },

                EVALUATION: {
                    PARTICIPANT_ROLE_LIST: ["EVALUATOR", "EVALUATOR_LEADER"],
                    PARTICIPANT_REF_DATA_LIST: ["PARTICIPANT_ROLE", "PARTICIPANT_NAME", "PARTICIPANT_EMAIL", "PARTICIPANT_PHONE", "PARTICIPANT_BIRTH_DATE", "PARTICIPANT_ORGANIZATION", "PARTICIPANT_POSITION", "ORGANIZATION_POSITION", "PARTICIPANT_NAME_ORGANIZATION_POSITION"],
                    PARTICIPANT_COLOR_LIST: ["#228be6", "#fab005", "#40c057", "#be4bdb", "#e64980", "#748ffc", "#ffa94d", "#a9e34b", "#3bc9db", "#ff8787", "#1864ab", "#e67700", "#2b8a3e", "#862e9c", "#a61e4d", "#364fc7", "#d9480f", "#5c940d", "#0b7285", "#c92a2a",]
                },
                EVALUATION_MENU: {
                    // 평가 정보
                    // "INFO", "INFO_CATEGORY"
                    INFO: true,
                    INFO_MENUS: ["INFO"],

                    // 평가 데이터
                    // "DOC_DATA", "DOC_PARTI"
                    COMMON_DATA: true,
                    COMMON_DATA_MENUS: ["DOC_DATA", "DOC_PARTI"],

                    // 문서 서식 - 공통
                    // "DOC_COMMON", "DOC_SIGNATURE_BOOK"
                    DOC_COMMON: true,
                    DOC_COMMON_MENUS: ["DOC_COMMON", "DOC_SIGNATURE_BOOK"],

                    // 문서 서식 - 피평가자
                    DOC_EVALUATEE: false,
                    DOC_EVALUATEE_MENUS: [],

                    // 문서 서식 - 평가자
                    // "DOC_AGREEMENT", "DOC_QUESTION", "DOC_SURVEY", "DOC_EVALUATION"
                    DOC_EVALUATOR: true,
                    DOC_EVALUATOR_MENUS: ["DOC_EVALUATION"],

                    // 문서 서식 - 취합지
                    // "DOC_GATHERING
                    DOC_GATHERING: true,
                    DOC_GATHERING_MENUS: ["DOC_GATHERING"],

                    // 참여자(평가위원)
                    // "EVALUATOR"
                    PARTICIPANT: true,
                    PARTICIPANT_MENUS: ["EVALUATOR"],
                },
                EVALUATION_OPEN_MENU: {
                    /* 기본 정보 */
                    INFO: true,
                    INFO_MENUS: ["INFO"],

                    /* 평가 정보 */
                    EVALUATION: false,
                    EVALUATION_MENUS: [],

                    /* 결과 정보 */
                    OUTPUT: true,
                    OUTPUT_MENUS: ["OUTPUT_FILE"],
                },
                EVALUATION_CLOSE_MENU: {
                    /* 기본 정보 */
                    INFO: true,
                    INFO_MENUS: ["INFO"],

                    /* 참여자 정보 */
                    PARTICIPANT: true,
                    PARTICIPANT_MENUS: ["EVALUATOR"]
                },

                PARTICIPANT_EVALUATOR: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    FUNC_EVALUATOR_DATA: false,
                    FUNC_EVALUATION_COMPLETE: false,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                PARTICIPANT_EVALUATOR_LEADER: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],

                    FUNC_EVALUATOR_DATA: true,
                    FUNC_EVALUATION_COMPLETE: true,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                PARTICIPANT_EVALUATOR_AND_LEADER: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],

                    FUNC_EVALUATOR_DATA: true,
                    FUNC_EVALUATION_COMPLETE: true,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                CUSTOM_RESOURCE: {
                    PARTICIPANT_EVALUATOR_PAGE_SIGN: {
                        BG: {
                            PATH: "custom/lhri/images/bg.png",
                            STYLE: {
                                "height": "200px",
                                "backgroundRepeat": "no-repeat",
                                "backgroundSize": "contain",
                                "backgroundPosition": "left top"
                            }
                        },
                        HEADER: {
                            STYLE: {
                                height: 200,
                                padding: 30,
                            },
                            TITLE_STYLE: {
                                marginTop: 16,
                                color: "#191919",
                            },
                            SUB_TITLE_STYLE: {
                                color: "#191919",
                            },
                            LOGO: {
                                PATH: "custom/lhri/images/logo.png",
                                STYLE: {
                                    width: "auto",
                                    height: 36,
                                }
                            },
                        },
                        BODY: {
                            STYLE: {
                                paddingTop: 30,
                            },
                        },
                        FOOTER: {
                            STYLE: {
                                textAlign: "center"
                            },
                            LOGO: {
                                PATH: "custom/lhri/images/logo.png",
                                STYLE: {
                                    width: "auto",
                                    height: 40,
                                }
                            },
                        },
                    },
                    PARTICIPANT_EVALUATOR_PAGE_MAIN: {
                        LOGO: {
                            PATH: "custom/lhri/images/logo.png",
                            STYLE: {
                                width: "auto",
                                height: 30,
                            }
                        },
                    },
                }
            }
        }
        else if (customMode === "krri") {
            initialState = {
                THEME: null,
                SYSTEM: {
                    // use
                    COMMUNICATION: {
                        METHOD: "POLLING",
                        POLLING: {
                            INTERVAL: 1000,
                        },
                        SSE: {
                            DOMAIN: ""
                        }
                    },
                    DATE_FORMAT: {
                        BIRTH_DATE: "YYYY.MM.DD",
                        CREATE_DATE: "YYYY-MM-DD HH:mm",
                        UPDATE_DATE: "YYYY-MM-DD HH:mm",
                        DEFAULT_DATE: "YYYY-MM-DD HH:mm",
                    },
                    INPUT_MAX_LENGTH: {
                        TEXT: 255,
                        PASSWORD: 255,
                        DATE: 8,
                        EMAIL: 255,
                        PHONE: 11,
                        COMMENT: 1024
                    },
                    FILE_ACCEPT: {
                        XLSX: ["xlsx"],
                        EVALUATION_DOCUMENT: ["pdf"],
                        EVALUATION_ATTACHMENT_FILE: ["pdf"],
                    },
                    FILE_UPLOAD_SIZE: {
                        XLSX: 100,
                        EVALUATION_DOCUMENT: 100,
                        EVALUATION_ATTACHMENT_FILE: 100,
                    },

                    USER_AUTH: {
                        PASSWORD: {
                            ENABLE: false,
                            REGEX: null,
                            IS_ALPHABET: false,                        // /[a-zA-Z]/.test(password)
                            IS_NUMBER: false,                          // /\d/.test(password)
                            IS_SPECIAL_CHARACTERS: false,               // /[$@!%*#?&]/.test(password)
                            IS_NEED_LENGTH_8: false,                     // password.length >= 8
                            IS_NEED_LENGTH_10: false                    // password.length >= 10
                        }
                    },
                    EVALUATOR_AUTH: {
                        TYPE: "EMAIL_PASSWORD",
                        PASSWORD: {
                            ENABLE: true,
                            REGEX: null,
                            IS_ALPHABET: true,                          // /[a-zA-Z]/.test(password)
                            IS_NUMBER: true,                            // /\d/.test(password)
                            IS_SPECIAL_CHARACTERS: true,                // /[$@!%*#?&]/.test(password)
                            IS_NEED_LENGTH_8: true,                     // password.length >= 8
                            IS_NEED_LENGTH_10: false                    // password.length >= 10
                        }
                    },
                    ENABLE_EVALUATION_CATEGORY: false,
                    ENABLE_EVALUATION_GATHERING_SHOWN: false,
                    ENABLE_RENDER_EVALUATOR_PARTICIPANT_CHANNEL: true,

                    FUNC_EVALUATOR_DATA_OPEN_TYPE: "MODAL", // MODAL or WINDOW
                },
                MAIN_MENU: {
                    // 공통 메뉴
                    BASE: true,
                    BASE_MENUS: ["MEMBER"],

                    // 관라지 메뉴
                    // "DASHBOARD", "ORGANIZATION", "EVALUATOR", "TEMPLATE"
                    ADMIN: true,
                    ADMIN_MENUS: ["DASHBOARD", "ORGANIZATION", "EVALUATOR", "TEMPLATE"],

                    // 사용자 메뉴
                    // 공통 메뉴
                    // "EVALUATION", "EVALUATION_OPEN", "EVALUATION_CLOSE"
                    EVALUATION: true,
                    EVALUATION_MENUS: ["EVALUATION", "EVALUATION_OPEN", "EVALUATION_CLOSE"],
                },

                APP_MEMBER: {
                    ENABLE: {
                        ROLE: false,
                        PHONE: true,
                    },
                    UNIQUE: {
                        PHONE: true
                    }
                },
                APP_ORGANIZATION: {
                    ITEMS: {
                        "role": false,
                        "name": true,
                        "email": true,
                        "phone": true,
                        "state": true,
                        "createdDate": true,
                        "updatedDate": true,
                    },
                    UNIQUE: {
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                    },
                    XLSX: {
                        COLUMNS: [                          // state 사용 안됨
                            {key: "name", require: true},
                            {key: "email", require: false},
                            {key: "phone", require: false},
                        ],
                        PARSER: {}
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name", "email", "phone"],
                        COLUMNS: [
                            {type: "select", key: "checkbox", style: {width: 46, minWidth: 46}},
                            {type: "sort", key: "name", style: {width: "auto"}},
                            {type: "sort", key: "email", style: {width: "15%"}},
                            {type: "sort", key: "phone", style: {width: "15%"}},
                            {type: "text", key: "state", style: {width: "15%"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    }
                },
                APP_EVALUATOR_POOL: {
                    ITEMS: {
                        "type": true,                   // 분야
                        "name": true,                   // 이름(필수)
                        "gender": true,                 // 성별
                        "birthDate": true,              // 생년월일
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                        "organization": true,           // 소속
                        "position": true,               // 직위
                        "responsibility": false,        // 직책
                        "rank": true,                   // 직급
                        "major": true,                  // 전공
                        "occupation": true,             // 직종
                        "certificate1": true,           // 자격증1
                        "certificate2": true,           // 자격증2
                        "homeAddress": true,            // 자택주소
                        "companyAddress": true,         // 직장주소
                        "remarks": true,                // 비고
                        "createdDate": true,            // 생성일
                        "updatedDate": true,            // 수정일

                        "domain": true,                 // 분야
                        "certificate3": true,          // 자격증3
                    },
                    UNIQUE: {
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                    },
                    XLSX: {
                        COLUMNS: [
                            {key: "type", require: true},
                            {key: "name", require: true},
                            {key: "organization", require: true},
                            {key: "position", require: true},
                            {key: "email", require: true},
                            {key: "phone", require: true},

                            {key: "gender", require: false},
                            {key: "birthDate", require: false},
                            {key: "homeAddress", require: false},
                            {key: "companyAddress", require: false},
                            {key: "major", require: false},
                            {key: "remarks", require: false},
                        ],
                        PARSER: {
                            "type": ["NONE", "INTERNAL", "EXTERNAL", "외부", "내부"],
                            "gender": ["MALE", "FEMALE", "남", "여", "남자", "여자"],
                            "birthDate": ["YYYYMMDD", "YYYY.MM.DD", "YYYY-MM-DD"],
                        }
                    },
                    TABLE: {
                        SORT: "domain,ASC&sort=name,ASC",
                        SEARCH_KEYS: ["name", "email", "phone", "domain", "organization"],
                        COLUMNS: [
                            {type: "select", key: "checkbox", style: {width: 46, minWidth: 46}},
                            {type: "text", key: "type", style: {width: "15%"}},
                            {type: "text", key: "name", style: {width: "15%"}},
                            {type: "text", key: "organization", style: {width: "15%"}},
                            {type: "text", key: "position", style: {width: "15%"}},
                            {type: "text", key: "email", style: {width: "15%"}},
                            {type: "text", key: "phone", style: {width: "15%"}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    },
                    INFO: {
                        COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
                    },
                    CREATE: {
                        COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
                        REQUIRE: ["type", "name", "email", "phone", "organization", "position"]
                    },
                    UPDATE: {
                        COLUMNS1: ["type", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
                        REQUIRE: ["type", "name", "email", "phone", "organization", "position"]
                    }
                },
                APP_EVALUATION_TEMPLATE: {
                    ITEMS: {
                        "name": true,
                        "description": true,
                        "createdDate": true,
                        "updatedDate": true,
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name"],
                        COLUMNS: [
                            {type: "sort", key: "name", style: {width: "20%"}},
                            {type: "text", key: "description", style: {width: "auto"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    }
                },
                APP_EVALUATION: {
                    ITEMS: {
                        "status": true,                 // 상태
                        "name": true,                   // 이름
                        "code": true,                   // 코드
                        "createdDate": true,            // 생성일
                        "updatedDate": true,            // 수정일
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name", "code"],
                        COLUMNS: [
                            {type: "text", key: "status", style: {width: "12%"}},
                            {type: "text", key: "code", style: {width: "12%"}},
                            {type: "text", key: "name", style: {width: "auto"}},
                            {type: "text", key: "location", style: {width: "12%"}},
                            {type: "text", key: "evaluationDate", style: {width: "12%"}},
                            {type: "text", key: "orderDepartmentName", style: {width: "12%"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                        ]
                    }
                },
                PAGE_EVALUATOR: {
                    MENUS: {
                        ITEM: {
                            SIGNATURE: true,

                            COMMON: true,

                            SIGNATURE_BOOK: true,
                            AGREEMENT: true,
                            QUESTION: true,
                            SURVEY: true,
                            EVALUATION: true,
                            EVALUATOR_LEADER: true,

                            GATHERING: true,
                        },

                        LIST: [
                            {type: "ITEM", item: "SIGNATURE"},
                            {type: "ITEM", item: "COMMON"},
                            {type: "ITEM", item: "AGREEMENT"},
                            {type: "ITEM", item: "EVALUATION"},
                            {type: "ITEM", item: "SIGNATURE_BOOK"},
                            {type: "ITEM", item: "GATHERING"},
                            {type: "ITEM", item: "EVALUATOR_LEADER"},
                        ],
                        ENABLE_AT_STEP_WAIT: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION"],     // eval - wait or open
                        ENABLE_AT_STEP_OPEN: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK"],  // eval -  open
                        ENABLE_AT_STEP_GATHERING: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],   // eval -  open - gathering
                        ENABLE_AT_STEP_RESULT: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],

                        ENABLE_AT_EVALUATOR: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK"],
                        ENABLE_AT_EVALUATOR_LEADER: ["SIGNATURE", "COMMON", "AGREEMENT", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],
                    }
                },

                EVALUATION: {
                    PARTICIPANT_ROLE_LIST: ["EVALUATOR", "EVALUATOR_LEADER"],
                    PARTICIPANT_REF_DATA_LIST: ["PARTICIPANT_ROLE", "PARTICIPANT_NAME", "PARTICIPANT_EMAIL", "PARTICIPANT_PHONE", "PARTICIPANT_BIRTH_DATE", "PARTICIPANT_ORGANIZATION", "PARTICIPANT_POSITION", "ORGANIZATION_POSITION", "PARTICIPANT_NAME_ORGANIZATION_POSITION"],
                    PARTICIPANT_COLOR_LIST: ["#228be6", "#fab005", "#40c057", "#be4bdb", "#e64980", "#748ffc", "#ffa94d", "#a9e34b", "#3bc9db", "#ff8787", "#1864ab", "#e67700", "#2b8a3e", "#862e9c", "#a61e4d", "#364fc7", "#d9480f", "#5c940d", "#0b7285", "#c92a2a",]
                },
                EVALUATION_MENU: {
                    // 평가 정보
                    // "INFO", "INFO_CATEGORY"
                    INFO: true,
                    INFO_MENUS: ["INFO", "INFO_CATEGORY"],

                    // 평가 데이터
                    // "DOC_DATA", "DOC_PARTI"
                    COMMON_DATA: true,
                    COMMON_DATA_MENUS: ["DOC_DATA", "DOC_PARTI"],

                    // 문서 서식 - 공통
                    // "DOC_COMMON", "DOC_SIGNATURE_BOOK"
                    DOC_COMMON: true,
                    DOC_COMMON_MENUS: ["DOC_COMMON", "DOC_SIGNATURE_BOOK"],

                    // 문서 서식 - 피평가자
                    DOC_EVALUATEE: false,
                    DOC_EVALUATEE_MENUS: [],

                    // 문서 서식 - 평가자
                    // "DOC_AGREEMENT", "DOC_QUESTION", "DOC_SURVEY", "DOC_EVALUATION"
                    DOC_EVALUATOR: true,
                    DOC_EVALUATOR_MENUS: ["DOC_AGREEMENT", "DOC_EVALUATION"],

                    // 문서 서식 - 취합지
                    // "DOC_GATHERING
                    DOC_GATHERING: true,
                    DOC_GATHERING_MENUS: ["DOC_GATHERING"],

                    // 참여자(평가위원)
                    // "EVALUATOR"
                    PARTICIPANT: true,
                    PARTICIPANT_MENUS: ["EVALUATOR"],
                },
                EVALUATION_OPEN_MENU: {
                    /* 기본 정보 */
                    INFO: true,
                    INFO_MENUS: ["INFO"],

                    /* 평가 정보 */
                    EVALUATION: false,
                    EVALUATION_MENUS: [],

                    /* 결과 정보 */
                    OUTPUT: true,
                    OUTPUT_MENUS: ["OUTPUT_FILE"],
                },
                EVALUATION_CLOSE_MENU: {
                    /* 기본 정보 */
                    INFO: true,
                    INFO_MENUS: ["INFO"],

                    /* 참여자 정보 */
                    PARTICIPANT: true,
                    PARTICIPANT_MENUS: ["EVALUATOR"]
                },

                PARTICIPANT_EVALUATOR: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    FUNC_EVALUATOR_DATA: false,
                    FUNC_EVALUATION_COMPLETE: false,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                PARTICIPANT_EVALUATOR_LEADER: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],

                    FUNC_EVALUATOR_DATA: true,
                    FUNC_EVALUATION_COMPLETE: true,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                PARTICIPANT_EVALUATOR_AND_LEADER: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],

                    FUNC_EVALUATOR_DATA: true,
                    FUNC_EVALUATION_COMPLETE: true,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                CUSTOM_RESOURCE: {
                    PARTICIPANT_EVALUATOR_PAGE_SIGN: {
                        BG: {
                            PATH: "custom/lhri/images/bg.png",
                            STYLE: {
                                "height": "200px",
                                "backgroundRepeat": "no-repeat",
                                "backgroundSize": "contain",
                                "backgroundPosition": "left top"
                            }
                        },
                        HEADER: {
                            STYLE: {
                                height: 200,
                                padding: 30,
                            },
                            TITLE_STYLE: {
                                marginTop: 16,
                                color: "#191919",
                            },
                            SUB_TITLE_STYLE: {
                                color: "#191919",
                            },
                            LOGO: {
                                PATH: "custom/lhri/images/logo.png",
                                STYLE: {
                                    width: "auto",
                                    height: 36,
                                }
                            },
                        },
                        BODY: {
                            STYLE: {
                                paddingTop: 30,
                            },
                        },
                        FOOTER: {
                            STYLE: {
                                textAlign: "center"
                            },
                            LOGO: {
                                PATH: "custom/lhri/images/logo.png",
                                STYLE: {
                                    width: "auto",
                                    height: 40,
                                }
                            },
                        },
                    },
                    PARTICIPANT_EVALUATOR_PAGE_MAIN: {
                        LOGO: {
                            PATH: "custom/lhri/images/logo.png",
                            STYLE: {
                                width: "auto",
                                height: 30,
                            }
                        },
                    },
                }
            }
        }
        else if (customMode === "keiti") {
            initialState = {
                THEME: null,
                SYSTEM: {
                    // use
                    COMMUNICATION: {
                        METHOD: "POLLING",
                        POLLING: {
                            INTERVAL: 1000,
                        },
                        SSE: {
                            DOMAIN: ""
                        }
                    },
                    DATE_FORMAT: {
                        BIRTH_DATE: "YYYY.MM.DD",
                        CREATE_DATE: "YYYY-MM-DD HH:mm",
                        UPDATE_DATE: "YYYY-MM-DD HH:mm",
                        DEFAULT_DATE: "YYYY-MM-DD HH:mm",
                    },
                    INPUT_MAX_LENGTH: {
                        TEXT: 255,
                        PASSWORD: 255,
                        DATE: 8,
                        EMAIL: 255,
                        PHONE: 11,
                        COMMENT: 1024
                    },
                    FILE_ACCEPT: {
                        XLSX: ["xlsx"],
                        EVALUATION_DOCUMENT: ["pdf"],
                        EVALUATION_ATTACHMENT_FILE: ["pdf"],
                    },
                    FILE_UPLOAD_SIZE: {
                        XLSX: 100,
                        EVALUATION_DOCUMENT: 100,
                        EVALUATION_ATTACHMENT_FILE: 100,
                    },

                    USER_AUTH: {
                        PASSWORD: {
                            ENABLE: false,
                            REGEX: null,
                            IS_ALPHABET: false,                        // /[a-zA-Z]/.test(password)
                            IS_NUMBER: false,                          // /\d/.test(password)
                            IS_SPECIAL_CHARACTERS: false,               // /[$@!%*#?&]/.test(password)
                            IS_NEED_LENGTH_8: false,                     // password.length >= 8
                            IS_NEED_LENGTH_10: false                    // password.length >= 10
                        }
                    },
                    EVALUATOR_AUTH: {
                        TYPE: "EMAIL_PASSWORD",
                        PASSWORD: {
                            ENABLE: true,
                            REGEX: null,
                            IS_ALPHABET: true,                          // /[a-zA-Z]/.test(password)
                            IS_NUMBER: true,                            // /\d/.test(password)
                            IS_SPECIAL_CHARACTERS: true,                // /[$@!%*#?&]/.test(password)
                            IS_NEED_LENGTH_8: true,                     // password.length >= 8
                            IS_NEED_LENGTH_10: false                    // password.length >= 10
                        }
                    },
                    ENABLE_EVALUATION_CATEGORY: false,
                    ENABLE_RENDER_EVALUATOR_PARTICIPANT_CHANNEL: true,

                    FUNC_EXTRACT_DATA: false,
                    FUNC_EXTRACT_DATA_FOR_QUESTION: false,
                    FUNC_EXTRACT_DATA_FOR_EVALUATOR_LEADER: true,

                    FUNC_EVALUATOR_DATA_UPDATE: false,
                    FUNC_EVALUATOR_DATA_OPEN_TYPE: "MODAL", // MODAL or WINDOW
                },
                MAIN_MENU: {
                    // 공통 메뉴
                    BASE: true,
                    BASE_MENUS: ["MEMBER"],

                    // 관라지 메뉴
                    // "DASHBOARD", "ORGANIZATION", "EVALUATOR", "TEMPLATE"
                    ADMIN: true,
                    ADMIN_MENUS: ["DASHBOARD", "ORGANIZATION", "EVALUATOR", "TEMPLATE"],

                    // 사용자 메뉴
                    // 공통 메뉴
                    // "EVALUATION", "EVALUATION_OPEN", "EVALUATION_CLOSE"
                    EVALUATION: true,
                    EVALUATION_MENUS: ["EVALUATION", "EVALUATION_OPEN", "EVALUATION_CLOSE"],
                },

                APP_MEMBER: {
                    ENABLE: {
                        ROLE: false,
                        PHONE: true,
                    },
                    UNIQUE: {
                        PHONE: true
                    }
                },
                APP_ORGANIZATION: {
                    ITEMS: {
                        "role": false,
                        "name": true,
                        "email": true,
                        "phone": true,
                        "state": true,
                        "createdDate": true,
                        "updatedDate": true,
                    },
                    UNIQUE: {
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                    },
                    XLSX: {
                        COLUMNS: [                          // state 사용 안됨
                            {key: "name", require: true},
                            {key: "email", require: false},
                            {key: "phone", require: false},
                        ],
                        PARSER: {}
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name", "email", "phone"],
                        COLUMNS: [
                            {type: "select", key: "checkbox", style: {width: 46, minWidth: 46}},
                            {type: "sort", key: "name", style: {width: "auto"}},
                            {type: "sort", key: "email", style: {width: "15%"}},
                            {type: "sort", key: "phone", style: {width: "15%"}},
                            {type: "text", key: "state", style: {width: "15%"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    }
                },
                APP_EVALUATOR_POOL: {
                    ITEMS: {
                        "type": true,                   // 유형
                        "domain": true,                 // 분야
                        "name": true,                   // 이름(필수)
                        "gender": true,                 // 성별
                        "birthDate": true,              // 생년월일
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                        "organization": true,           // 소속
                        "position": true,               // 직위
                        "responsibility": false,        // 직책
                        "rank": true,                   // 직급
                        "major": true,                  // 전공
                        "occupation": true,             // 직종
                        "certificate1": true,           // 자격증1
                        "certificate2": true,           // 자격증2
                        "certificate3": true,           // 자격증3
                        "homeAddress": true,            // 자택주소
                        "companyAddress": true,         // 직장주소
                        "remarks": true,                // 비고
                        "createdDate": true,            // 생성일
                        "updatedDate": true,            // 수정일
                    },
                    UNIQUE: {
                        "email": true,                  // 이메일
                        "phone": true,                  // 휴대폰번호
                    },
                    XLSX: {
                        COLUMNS: [
                            {key: "type", require: true},
                            {key: "domain", require: true},
                            {key: "name", require: true},
                            {key: "organization", require: true},
                            {key: "position", require: true},
                            {key: "email", require: true},
                            {key: "phone", require: true},

                            {key: "gender", require: false},
                            {key: "birthDate", require: false},
                            {key: "homeAddress", require: false},
                            {key: "companyAddress", require: false},
                            {key: "occupation", require: false},
                            {key: "major", require: false},
                            {key: "remarks", require: false},
                        ],
                        PARSER: {
                            "type": ["NONE", "INTERNAL", "EXTERNAL", "외부", "내부"],
                            "gender": ["MALE", "FEMALE", "남", "여", "남자", "여자"],
                            "birthDate": ["YYYYMMDD", "YYYY.MM.DD", "YYYY-MM-DD"],
                        }
                    },
                    TABLE: {
                        SORT: "domain,ASC&sort=name,ASC",
                        SEARCH_KEYS: ["name", "email", "phone", "domain", "organization"],
                        COLUMNS: [
                            {type: "select", key: "checkbox", style: {width: 46, minWidth: 46}},
                            {type: "text", key: "type", style: {width: "10%"}},
                            {type: "text", key: "domain", style: {width: "10%"}},
                            {type: "text", key: "name", style: {width: "15%"}},
                            {type: "text", key: "organization", style: {width: "12%"}},
                            {type: "text", key: "position", style: {width: "12%"}},
                            {type: "text", key: "email", style: {width: "15%"}},
                            {type: "text", key: "phone", style: {width: "15%"}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    },
                    INFO: {
                        COLUMNS1: ["type", "domain", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "major", "remarks"],
                    },
                    CREATE: {
                        COLUMNS1: ["type", "domain", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "occupation", "major", "remarks"],
                        REQUIRE: ["type", "domain", "name", "email", "phone", "organization", "position"]
                    },
                    UPDATE: {
                        COLUMNS1: ["type", "domain", "name", "organization", "position", "email", "phone"],
                        COLUMNS2: ["gender", "birthDate", "homeAddress", "companyAddress", "occupation", "major", "remarks"],
                        REQUIRE: ["type", "domain", "name", "email", "phone", "organization", "position"]
                    }
                },
                APP_EVALUATION_TEMPLATE: {
                    ITEMS: {
                        "name": true,
                        "description": true,
                        "createdDate": true,
                        "updatedDate": true,
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name"],
                        COLUMNS: [
                            {type: "sort", key: "name", style: {width: "20%"}},
                            {type: "text", key: "description", style: {width: "auto"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                            {type: "text", key: "action", style: {minWidth: 180, width: 180}},
                        ]
                    }
                },
                APP_EVALUATION: {
                    ITEMS: {
                        "status": true,                 // 상태
                        "name": true,                   // 이름
                        "code": true,                   // 코드
                        "createdDate": true,            // 생성일
                        "updatedDate": true,            // 수정일
                    },
                    TABLE: {
                        SORT: null,
                        SEARCH_KEYS: ["name", "code"],
                        COLUMNS: [
                            {type: "text", key: "status", style: {width: "12%"}},
                            {type: "text", key: "code", style: {width: "12%"}},
                            {type: "text", key: "name", style: {width: "auto"}},
                            {type: "text", key: "location", style: {width: "12%"}},
                            {type: "text", key: "evaluationDate", style: {width: "12%"}},
                            {type: "text", key: "orderDepartmentName", style: {width: "12%"}},
                            {type: "sort", key: "createdDate", style: {minWidth: 160, width: 160}},
                            {type: "sort", key: "updatedDate", style: {minWidth: 160, width: 160}},
                        ]
                    }
                },
                PAGE_EVALUATOR: {
                    MENUS: {
                        ITEM: {
                            SIGNATURE: true,

                            COMMON: true,

                            SIGNATURE_BOOK: true,
                            AGREEMENT: true,
                            QUESTION: true,
                            SURVEY: true,
                            EVALUATION: true,
                            EVALUATOR_LEADER: true,

                            GATHERING: true,
                        },

                        LIST: [
                            {type: "ITEM", item: "SIGNATURE"},
                            {type: "ITEM", item: "COMMON"},
                            {type: "ITEM", item: "AGREEMENT"},
                            {type: "ITEM", item: "EVALUATION"},
                            {type: "ITEM", item: "SIGNATURE_BOOK"},
                            {type: "ITEM", item: "GATHERING"},
                            {type: "ITEM", item: "EVALUATOR_LEADER"},
                        ],
                        ENABLE_AT_STEP_WAIT: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION"],     // eval - wait or open
                        ENABLE_AT_STEP_OPEN: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK"],  // eval -  open
                        ENABLE_AT_STEP_GATHERING: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],   // eval -  open - gathering
                        ENABLE_AT_STEP_RESULT: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],

                        ENABLE_AT_EVALUATOR: ["SIGNATURE", "COMMON", "AGREEMENT", "EVALUATION", "SIGNATURE_BOOK"],
                        ENABLE_AT_EVALUATOR_LEADER: ["SIGNATURE", "COMMON", "AGREEMENT", "SIGNATURE_BOOK", "GATHERING", "EVALUATOR_LEADER"],
                    }
                },

                EVALUATION: {
                    PARTICIPANT_ROLE_LIST: ["EVALUATOR", "EVALUATOR_LEADER"],
                    PARTICIPANT_REF_DATA_LIST: ["PARTICIPANT_ROLE", "PARTICIPANT_NAME", "PARTICIPANT_EMAIL", "PARTICIPANT_PHONE", "PARTICIPANT_BIRTH_DATE", "PARTICIPANT_ORGANIZATION", "PARTICIPANT_POSITION", "ORGANIZATION_POSITION", "PARTICIPANT_NAME_ORGANIZATION_POSITION"],
                    PARTICIPANT_COLOR_LIST: ["#228be6", "#fab005", "#40c057", "#be4bdb", "#e64980", "#748ffc", "#ffa94d", "#a9e34b", "#3bc9db", "#ff8787", "#1864ab", "#e67700", "#2b8a3e", "#862e9c", "#a61e4d", "#364fc7", "#d9480f", "#5c940d", "#0b7285", "#c92a2a",]
                },
                EVALUATION_MENU: {
                    // 평가 정보
                    // "INFO", "INFO_CATEGORY"
                    INFO: true,
                    INFO_MENUS: ["INFO"],

                    // 평가 데이터
                    // "DOC_DATA", "DOC_PARTI"
                    COMMON_DATA: true,
                    COMMON_DATA_MENUS: ["DOC_DATA", "DOC_PARTI"],

                    // 문서 서식 - 공통
                    // "DOC_COMMON", "DOC_SIGNATURE_BOOK"
                    DOC_COMMON: true,
                    DOC_COMMON_MENUS: ["DOC_COMMON", "DOC_SIGNATURE_BOOK"],

                    // 문서 서식 - 피평가자
                    DOC_EVALUATEE: false,
                    DOC_EVALUATEE_MENUS: [],

                    // 문서 서식 - 평가자
                    // "DOC_AGREEMENT", "DOC_QUESTION", "DOC_SURVEY", "DOC_EVALUATION"
                    DOC_EVALUATOR: true,
                    DOC_EVALUATOR_MENUS: ["DOC_EVALUATION"],

                    // 문서 서식 - 취합지
                    // "DOC_GATHERING
                    DOC_GATHERING: true,
                    DOC_GATHERING_MENUS: ["DOC_GATHERING"],

                    // 참여자(평가위원)
                    // "EVALUATOR"
                    PARTICIPANT: true,
                    PARTICIPANT_MENUS: ["EVALUATOR"],
                },
                EVALUATION_OPEN_MENU: {
                    /* 기본 정보 */
                    INFO: true,
                    INFO_MENUS: ["INFO"],

                    /* 평가 정보 */
                    EVALUATION: false,
                    EVALUATION_MENUS: [],

                    /* 결과 정보 */
                    OUTPUT: true,
                    OUTPUT_MENUS: ["OUTPUT_FILE"],
                },
                EVALUATION_CLOSE_MENU: {
                    /* 기본 정보 */
                    INFO: true,
                    INFO_MENUS: ["INFO"],

                    /* 참여자 정보 */
                    PARTICIPANT: true,
                    PARTICIPANT_MENUS: ["EVALUATOR"]
                },

                PARTICIPANT_EVALUATOR: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    FUNC_EVALUATOR_DATA: false,
                    FUNC_EVALUATION_COMPLETE: false,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                PARTICIPANT_EVALUATOR_LEADER: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],

                    FUNC_EVALUATOR_DATA: true,
                    FUNC_EVALUATION_COMPLETE: true,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                PARTICIPANT_EVALUATOR_AND_LEADER: {
                    MENUS: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_WAIT: [
                        "SIGNATURE_BOOK",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_OPEN: [],
                    DISABLE_MENUS_STEP_GATHERING: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],
                    DISABLE_MENUS_STEP_RESULT: [
                        "SIGNATURE",
                        "COMMON",
                        "SIGNATURE_BOOK",
                        "AGREEMENT",
                        "EVALUATION",
                    ],

                    FUNC_EVALUATOR_DATA: true,
                    FUNC_EVALUATION_COMPLETE: true,
                    COMPLETED_EVALUATION_STEP: "GATHERING"
                },
                CUSTOM_RESOURCE: {
                    PARTICIPANT_EVALUATOR_PAGE_SIGN: {
                        TITLE: "인투소프트",
                        BG: {
                            PATH: "images/customer/bg.jpg",
                            STYLE: {
                                "height": "200px",
                                "backgroundRepeat": "no-repeat",
                                "backgroundSize": "cover",
                                "backgroundPosition": "center"
                            }
                        },
                        HEADER: {
                            STYLE: {
                                height: 200,
                                padding: 30,
                            },
                            TITLE_STYLE: {
                                marginTop: 30,
                                color: "#FFFFFF",
                            },
                            SUB_TITLE_STYLE: {
                                display: "none",
                                color: "#FFFFFF",
                            },
                            LOGO: {
                                PATH: "images/customer/logo_white.svg",
                                STYLE: {
                                    width: "auto",
                                    height: 26,
                                }
                            },
                        },
                        BODY: {
                            STYLE: {
                                paddingTop: 30,
                            },
                        },
                        FOOTER: {
                            STYLE: {
                                textAlign: "center"
                            },
                            LOGO: {
                                PATH: "images/customer/logo.png",
                                STYLE: {
                                    width: "auto",
                                    height: 40,
                                }
                            },
                        },
                    },
                    PARTICIPANT_EVALUATOR_PAGE_MAIN: {
                        LOGO: {
                            PATH: "images/customer/logo.png",
                            STYLE: {
                                width: "auto",
                                height: 30,
                            }
                        },
                    },
                },
            }
        }
    }

    if (globalIntoSettings.SYSTEM) {
        initialState.SYSTEM = {
            ...initialState.SYSTEM,
            ...globalIntoSettings.SYSTEM,
        };
    }

    if (globalIntoSettings.EVALUATION_MENU) {
        initialState.EVALUATION_MENU = {
            ...initialState.EVALUATION_MENU,
            ...globalIntoSettings.EVALUATION_MENU,
        };
    }
    if (globalIntoSettings.EVALUATION_OPEN_MENU) {
        initialState.EVALUATION_OPEN_MENU = {
            ...initialState.EVALUATION_OPEN_MENU,
            ...globalIntoSettings.EVALUATION_OPEN_MENU,
        };
    }
    if (globalIntoSettings.EVALUATION_CLOSE_MENU) {
        initialState.EVALUATION_CLOSE_MENU = {
            ...initialState.EVALUATION_CLOSE_MENU,
            ...globalIntoSettings.EVALUATION_CLOSE_MENU,
        };
    }

    if (globalIntoSettings.PARTICIPANT_EVALUATION) {
        initialState.PARTICIPANT_EVALUATION = {
            ...initialState.PARTICIPANT_EVALUATION,
            ...globalIntoSettings.PARTICIPANT_EVALUATION,
        };
    }

    if (globalIntoSettings.PARTICIPANT_EVALUATOR) {
        initialState.PARTICIPANT_EVALUATOR = {
            ...initialState.PARTICIPANT_EVALUATOR,
            ...globalIntoSettings.PARTICIPANT_EVALUATOR,
        };
    }

    if (globalIntoSettings.PARTICIPANT_EVALUATOR_LEADER) {
        initialState.PARTICIPANT_EVALUATOR_LEADER = {
            ...initialState.PARTICIPANT_EVALUATOR_LEADER,
            ...globalIntoSettings.PARTICIPANT_EVALUATOR_LEADER,
        };
    }

    if (globalIntoSettings.PARTICIPANT_EVALUATOR_AND_LEADER) {
        initialState.PARTICIPANT_EVALUATOR_AND_LEADER = {
            ...initialState.PARTICIPANT_EVALUATOR_AND_LEADER,
            ...globalIntoSettings.PARTICIPANT_EVALUATOR_AND_LEADER,
        };
    }

    if (globalIntoSettings.CUSTOM_RESOURCE) {
        initialState.CUSTOM_RESOURCE = {
            ...initialState.CUSTOM_RESOURCE,
            ...globalIntoSettings.CUSTOM_RESOURCE,
        };
    }
}

const settingReducer = (state = initialState) => {
    return state;
}

export default settingReducer;